import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';
import { getFibesabeLink } from '../utils/firebase-link';

export default abstract class CertificateDao {
  static async fetchInfo(
    env: Environment,
    level: number,
    contactId: string
  ): Promise<{
    imageUrl: string;
    shareableLink: string;
  }> {
    const url = hostsConfig[env].progressServiceUrl;

    const { data } = await axios.post(`${url}/v1/certificates/image/url`, {
      contactId,
      level,
    });

    const shareableLink = await getFibesabeLink(
      `${hostsConfig[env].learningPlatform}/certificate.html?src=${Buffer.from(
        data
      ).toString('base64')}`
    );

    return {
      imageUrl: data,
      shareableLink,
    };
  }

  static async getCertificateDownloadUrl(
    env: Environment,
    level: number,
    contactId: string
  ) {
    const url = hostsConfig[env].progressServiceUrl;
    return `${url}/v1/certificates/pdf/${contactId}/${level}`;
  }
}
